const HAS_SMS_PERMISSION_RESPONSE = {
	NOT_NOW: 0,
	ALLOW: 4,
	DENY: 3,
	NEVER_ASK: 5
};

const SMS_PERMISSION_DIALOG_TEXT = {
	TITLE: 'Allow SMS Access',
	MESSAGE_BODY: 'Flipkart reads the One Time Password (OTP) verification code for a smoother purchase experience.'
};

class FKPay {
	autocapturePossible;
	autocaptureStarted;
	smsPermissionRequestCount;
	smsPermissionCallback;
	smsCaptureCallback;

	getAndroidOSMajorVersion = userAgent => {
		const regExp = /(Android )(\d)(.(\d))*;/gi;
		const result = regExp.exec(userAgent);
		if (result !== null && result.length >= 2) {
			return parseInt(result[2]);
		}
		return -1;
	};

	getFkAppVersion = userAgent => {
		const regExp = /FKUA\/Retail\/(\d+)\/Android\/Mobile/gi;
		const result = regExp.exec(userAgent);
		if (result !== null && result.length === 2) {
			return parseInt(result[1]);
		}
		return -1;
	};

	noOp = () => {
		return;
	};

	constructor() {
		this.autocapturePossible = false;
		this.autocaptureStarted = false;
		this.smsPermissionRequestCount = 0;
		this.smsPermissionCallback = this.noOp;
		this.smsCaptureCallback = this.noOp;
	}

	isNotNullOrUndefined = function (value) {
		return value != null;
	};

	isAutocaptureStarted = () => this.autocaptureStarted;
	setAutocaptureStarted = autoCaptureStarted => {
		this.autocaptureStarted = autoCaptureStarted;
	};

	isAutocapturePossible = () => this.autocapturePossible;
	setAutocapturePossible = autocapturePossible => {
		this.autocapturePossible = autocapturePossible;
	};

	getSmsPermissionRequestCount = () => this.smsPermissionRequestCount;
	incrementSmsPermissionRequestCount = () => {
		this.smsPermissionRequestCount++;
	};

	onSmsCapture = message => {
		this.smsCaptureCallback && this.smsCaptureCallback(true, message);
	};

	onSmsCaptureFailed = status => {
		this.smsCaptureCallback && this.smsCaptureCallback(false, status);
	};

	setSMSReceivePermissionResponse = responseCode => {
		switch (responseCode) {
			case HAS_SMS_PERMISSION_RESPONSE.ALLOW:
				this.setAutocapturePossible(true);
				break;
			case HAS_SMS_PERMISSION_RESPONSE.NOT_NOW:
			case HAS_SMS_PERMISSION_RESPONSE.DENY:
			case HAS_SMS_PERMISSION_RESPONSE.NEVER_ASK:
			default:
				this.setAutocapturePossible(false);
		}

		this.smsPermissionCallback();
	};

	checkIsSmsAutocapturePossible = () => {
		if (this.isNotNullOrUndefined(window.Android)) {
			const restrictedOSMajorVersion = 6;
			const currentOSMajorVersion = this.getAndroidOSMajorVersion(navigator.userAgent);
			if (currentOSMajorVersion === -1) {
				//cant figure out android os version? assume otp not possible
				this.setAutocapturePossible(false);
			} else if (currentOSMajorVersion >= restrictedOSMajorVersion) {
				//For Android 6 and higher...support check for otp support only from app version 680000 and higher
				let bugFixedAndroidAppVersion = 680000;
				let currentFkAppVersion = this.getFkAppVersion(navigator.userAgent);
				if (currentFkAppVersion >= bugFixedAndroidAppVersion) {
					if (
						window.Android &&
						typeof window.Android.hasSMSReceivePermission === 'function' &&
						typeof window.Android.captureAndHoldSms === 'function'
					) {
						try {
							window.Android.hasSMSReceivePermission('fkPay.setAutocapturePossible');
						} catch (e) {
							console.log(
								'Exception caught in calling: window.Android.hasSMSReceivePermission from checkIsSmsAutocapturePossible()',
								'error'
							);
						}
					}
				}
			} else {
				if (window.Android && this.isNotNullOrUndefined(window.Android['captureAndHoldSms'])) {
					this.setAutocapturePossible(true);
				}
			}
		}
	};

	startListeningToSms = (senderRegEx, timeoutSeconds, smsCaptureCallback) => {
		this.smsCaptureCallback = smsCaptureCallback;

		if (window.Android && typeof window.Android.startListeningToSMS === 'function') {
			try {
				window.Android.startListeningToSMS(
					senderRegEx,
					timeoutSeconds,
					'fkPay.onSmsCapture',
					'fkPay.onSmsCaptureFailed'
				);
			} catch (e) {
				console.log('Exception caught in calling: window.Android.startListeningToSms; arguments: ', 'error');
			}
		} else {
			this.onSmsCaptureFailed('NOT_SUPPORTED', '');
		}
	};

	stopListeningToSms = () => {
		if (window.Android && typeof window.Android.stopListeningToSMS === 'function') {
			try {
				window.Android.stopListeningToSMS();
			} catch (e) {
				console.log('Exception caught in calling: window.Android.stopListeningToSms', 'error');
			}
		}
	};

	captureAndHold = (senderRegEx, timeoutSeconds) => {
		if (window.Android && typeof window.Android.captureAndHoldSms === 'function') {
			try {
				window.Android.captureAndHoldSms(senderRegEx, timeoutSeconds, 'fkPay.setAutocaptureStarted');
			} catch (e) {
				console.log('Exception caught in calling: window.Android.captureAndHoldSms; arguments : ', 'error');
			}
		}
	};

	getSMSReceivePermission = callback => {
		this.smsPermissionCallback = callback;
		this.checkIsSmsAutocapturePossible();
		setTimeout(() => {
			if (
				!this.isAutocapturePossible() &&
				this.getSmsPermissionRequestCount() === 0 &&
				window.Android &&
				typeof window.Android.getSMSReceivePermission === 'function'
			) {
				this.incrementSmsPermissionRequestCount();

				try {
					window.Android.getSMSReceivePermission(
						SMS_PERMISSION_DIALOG_TEXT.TITLE,
						SMS_PERMISSION_DIALOG_TEXT.MESSAGE_BODY,
						'fkPay.setSMSReceivePermissionResponse'
					);
				} catch (e) {
					console.log(
						'Exception caught in calling: window.Android.getSMSReceivePermission; arguments: ',
						'error'
					);
				}
			} else {
				callback();
			}
		}, 0);
	};

	extractOtpFromSMS = (message, smsValidationPattern, otpPattern) => {
		if (this.isNotNullOrUndefined(message) && smsValidationPattern && otpPattern) {
			smsValidationPattern.lastIndex = 0;
			if (message.match(smsValidationPattern)) {
				otpPattern.lastIndex = 0;
				const otpMatches = message.match(otpPattern);
				if (otpMatches && otpMatches.length > 0) {
					return otpMatches[0];
				}
			}
		}
		return '';
	};
}

let fkPay = new FKPay();
window.fkPay = fkPay;
export { fkPay };
